import { $prose } from '@milkdown/kit/utils';
import { keymap } from '@milkdown/kit/prose/keymap';
import { TextSelection } from '@milkdown/kit/prose/state';

import { NOTICE_NODE_NAME, NOTICE_TOOLTIP_NAME } from './constants';

/**
 * Keymap plugin: Backspace removes empty notice block; Tab navigates to tooltip
 */
export const noticeKeymap = $prose(() => {
  return keymap({
    Backspace: (state, dispatch) => {
      const { $from } = state.selection;
      for (let depth = $from.depth; depth > 0; depth--) {
        const node = $from.node(depth);
        if (node.type.name === NOTICE_NODE_NAME) {
          if (node.textContent.trim() === '') {
            const start = $from.before(depth);
            const end = $from.after(depth);
            const tr = state.tr.delete(start, end);
            tr.setSelection(TextSelection.near(tr.doc.resolve(start)));
            if (dispatch) dispatch(tr);

            return true;
          }
          break;
        }
      }

      return false;
    },
    Tab: (state, _dispatch, view) => {
      if (!view?.editable) return false;

      const { $from } = state.selection;
      for (let depth = $from.depth; depth > 0; depth--) {
        if ($from.node(depth).type.name === NOTICE_NODE_NAME) {
          // Scope query to current editor's parent to avoid cross-editor tooltip conflicts
          const editorParent = view?.dom.parentElement;
          const tooltip = editorParent?.querySelector(`[data-name="${NOTICE_TOOLTIP_NAME}"]`);
          const activeButton = tooltip?.querySelector('button[aria-selected="true"]') ?? tooltip?.querySelector('button');
          if (activeButton instanceof HTMLButtonElement) {
            activeButton.focus();

            return true;
          }
        }
      }

      return false;
    },
  });
});
